import { Modal } from 'bootstrap';

const YM_ID = 98646072;

const KEYS = {
    calc: 'mortgage_auto_calc_shown',
    room: 'mortgage_auto_room_shown',
};

const MODALS = {
    pay: {
        id: 'mortgagePayModal',
        sourceId: 'mortgagePaySource',
        showGoal: 'show_mortgage_pay',
    },
    calc: {
        id: 'mortgageCalcModal',
        sourceId: 'mortgageCalcSource',
        showGoal: 'show_mortgage_calc',
    },
    room: {
        id: 'mortgageRoomModal',
        sourceId: 'mortgageRoomSource',
        showGoal: 'show_mortgage_room',
    },
};

const TARGET_TO_TYPE = {
    '#mortgagePayModal': 'pay',
    '#mortgageRoomModal': 'room',
    '#mortgageCalcModal': 'calc',
};

let roomQueued = false;
let payExitIntentShown = false;

function isProductPage() {
    return document.body.dataset.pageId === 'product'
        || /^\/product(\/|$)/.test(window.location.pathname);
}

function isHomePage() {
    return document.body.dataset.pageId === 'home'
        || window.location.pathname === '/';
}

function isModalOpen() {
    return !!document.querySelector('.modal.show');
}

function isShown(key) {
    return sessionStorage.getItem(key) === '1';
}

function markShown(key) {
    sessionStorage.setItem(key, '1');
}

function reachGoal(goal) {
    if (typeof ym !== 'undefined') {
        ym(YM_ID, 'reachGoal', goal);
    }
}

function setSource(sourceId, value) {
    const input = document.getElementById(sourceId);
    if (input) {
        input.value = value;
    }
}

function openModal(type, { source, auto = true, oncePerSession = true }) {
    const cfg = MODALS[type];
    const el = document.getElementById(cfg.id);
    if (!el) {
        return false;
    }

    const key = KEYS[type];
    if (auto && oncePerSession && key && isShown(key)) {
        return false;
    }
    if (isModalOpen()) {
        return false;
    }

    const scrollY = window.scrollY;

    setSource(cfg.sourceId, source);

    const keepScrollPosition = function () {
        window.scrollTo(0, scrollY);
    };

    el.addEventListener('show.bs.modal', keepScrollPosition, { once: true });
    el.addEventListener('shown.bs.modal', keepScrollPosition, { once: true });

    Modal.getOrCreateInstance(el, { focus: false }).show();

    requestAnimationFrame(keepScrollPosition);

    if (auto) {
        if (oncePerSession && key) {
            markShown(key);
        }
        reachGoal(cfg.showGoal);
    }

    return true;
}

function tryShowQueuedRoom() {
    if (!roomQueued || isShown(KEYS.room) || isModalOpen()) {
        return;
    }

    roomQueued = false;
    openModal('room', { source: 'auto:timer_20s_product', auto: true });
}

function initManualTriggers() {
    document.querySelectorAll('[data-mortgage-source]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            const target = this.getAttribute('data-bs-target') || '';
            const source = this.getAttribute('data-mortgage-source') || this.textContent.trim();
            const type = TARGET_TO_TYPE[target];

            if (!type) {
                return;
            }

            setSource(MODALS[type].sourceId, source);

            if (type === 'calc') {
                markShown(KEYS.calc);
            }
        });
    });
}

function initModalQueue() {
    Object.values(MODALS).forEach(function (cfg) {
        const el = document.getElementById(cfg.id);
        if (el) {
            el.addEventListener('hidden.bs.modal', tryShowQueuedRoom);
        }
    });
}

function initCalcTimer() {
    if (isProductPage()) {
        window.setTimeout(function () {
            if (!isShown(KEYS.calc)) {
                const opened = openModal('calc', { source: 'auto:timer_20s_product', auto: true });
                if (!isShown(KEYS.room)) {
                    if (opened) {
                        roomQueued = true;
                    } else if (!isModalOpen()) {
                        openModal('room', { source: 'auto:timer_20s_product', auto: true });
                    }
                }
                return;
            }

            if (!isShown(KEYS.room) && !isModalOpen()) {
                openModal('room', { source: 'auto:timer_20s_product', auto: true });
            }
        }, 20000);
        return;
    }

    // На главной автопоказ «комфортный платёж» отключён
    if (isHomePage()) {
        return;
    }

    window.setTimeout(function () {
        openModal('calc', { source: 'auto:timer_15s', auto: true });
    }, 15000);
}

function initExitIntent() {
    if (!window.matchMedia('(pointer: fine)').matches) {
        return;
    }

    document.documentElement.addEventListener('mouseleave', function (e) {
        if (e.clientY > 0 || payExitIntentShown) {
            return;
        }

        const opened = openModal('pay', { source: 'auto:exit_intent', auto: true, oncePerSession: false });
        if (opened) {
            payExitIntentShown = true;
        }
    });
}

function initModalScrollFix() {
    Object.values(MODALS).forEach(function (cfg) {
        const el = document.getElementById(cfg.id);
        if (!el) {
            return;
        }

        let scrollY = 0;

        el.addEventListener('show.bs.modal', function () {
            scrollY = window.scrollY;
        });

        el.addEventListener('hidden.bs.modal', function () {
            window.scrollTo(0, scrollY);
        });
    });
}

function initMortgageModalsAuto() {
    initManualTriggers();
    initModalQueue();
    initModalScrollFix();
    initCalcTimer();
    initExitIntent();
}

document.addEventListener('DOMContentLoaded', initMortgageModalsAuto);
